module.exports = {"130403001":"丛台西街道","130403002":"联纺西街道","130403003":"联纺东街道","130403004":"光明桥街道","130403005":"丛台东街道","130403006":"四季青街道","130403007":"和平街道","130403008":"中华街道","130403009":"人民路街道","130403010":"柳林桥街道","130403101":"黄粱梦镇","130403200":"苏曹乡","130403205":"三陵乡","130403206":"南吕固乡","130403207":"兼庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130403.json
// module id = 195
// module chunks = 0